/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import {webApi} from '../../../lib/WebApi'
import {statAdminEvent} from '../../../util/analytics'

export const LOAD_TEAMS_STARTED = 'LOAD_TEAMS_STARTED'
export function loadTeamsStarted() {
    return {
        type: LOAD_TEAMS_STARTED,
    }
}

export const LOAD_TEAMS_SUCCESSED = 'LOAD_TEAMS_SUCCESSED'
export function loadTeamsSuccessed(teams) {
    teams.sort((team1, team2) => team1.title.localeCompare(team2.title))
    return {
        type: LOAD_TEAMS_SUCCESSED,
        teams: teams
    }
}

export const LOAD_TEAM_USERS_SUCCESSED = 'LOAD_TEAM_USERS_SUCCESSED'
export function loadTeamUsersSuccessed(users) {
    users.forEach((user) => user.full_name = `${user.first_name} ${user.last_name}`)
    users.sort((user1, user2) => user1.full_name.localeCompare(user2.full_name))
    return {
        type: LOAD_TEAM_USERS_SUCCESSED,
        users: users
    }
}

export const LOAD_TEAMS_FAILED = 'LOAD_TEAMS_FAILED'
export function loadTeamsFailed() {
    return {
        type: LOAD_TEAMS_FAILED,
    }
}

export const LOAD_TEAM_USERS_FAILED = 'LOAD_TEAM_USERS_FAILED'
export function loadTeamUsersFailed() {
    return {
        type: LOAD_TEAM_USERS_FAILED,
    }
}

export function loadTeams() {
    return function(dispatch) {
        dispatch(loadTeamsStarted())
        dispatch(loadTeamsRequest((err, teams) => {
            if (err) {
                dispatch(loadTeamsFailed())
            } else {
                dispatch(loadTeamsSuccessed(teams))
            }
        }))
    }
}

export function loadTeamsByDivision(divisionId, callback) {
    return function(dispatch) {
        dispatch(loadTeamsStarted())
        dispatch(loadTeamsRequestByDivision(divisionId, (err, teams) => {
            if (err) {
                dispatch(loadTeamsFailed())
            } else {
                dispatch(loadTeamsSuccessed(teams))
            }
            if(callback) callback(err, teams)
        }))
    }
}

export function loadTeamUsersById(teamId) {
    return function(dispatch) {
        dispatch(loadUsersByTeamRequest(teamId, (err, users) => {
            if (err) {
                dispatch(loadTeamUsersFailed())
            } else {
                dispatch(loadTeamUsersSuccessed(users))
            }
        }))
    }
}

export function updateTeam(teamId, data, divisionId) {
    return (dispatch) => {
        dispatch(updateTeamStarted())
        dispatch(updateTeamRequest(teamId, data, (err) => {
            if(err) {
                dispatch(updateTeamFailed())
            } else {
                statAdminEvent(divisionId, 'update-team', 'teams')
                //dispatch(updateTeamSucceded());
                //dispatch(loadTeamsByDivision(divisionId));
                dispatch({
                    type: 'COMMON_SET',
                    key: 'divisions',
                    value: {
                        complete: false
                    }
                })
                dispatch({
                    type: 'COMMON_SET',
                    key: 'team_staff',
                    value: {
                        complete: false
                    }
                })
            }
        }))
    }
}

export function addTeamWithDivision(data, divisionId, userTeamRoles, callback) {
    return (dispatch) => {
        dispatch(addTeamStarted())
        dispatch(addTeamWithDivisionRequest(data, divisionId, userTeamRoles, (err) => {
            if(err) {
                dispatch(addTeamFailed())
            } else {
                statAdminEvent(divisionId, 'add-team', 'teams')
                dispatch(addTeamSucceded())
                dispatch({
                    type: 'COMMON_SET',
                    key: 'divisions',
                    value: {
                        complete: false,
                        loading: false,
                        error: null,
                        value: null,
                    },
                    note: 'reset divisions, after add team'
                })
                dispatch(loadTeamsByDivision(divisionId, callback))
            }
        }))
    }
}

export function deleteTeamFromDivision(divisionTeamId, divisionId) {
    return (dispatch) => {
        dispatch(deleteTeamFromDivisionRequest(divisionTeamId, (err) => {
            statAdminEvent(divisionId, 'delete-team', 'teams')
            dispatch(loadTeamsByDivision(divisionId))
        }))
    }
}

export function resetTeamMember(divisionId, member) {
    return (dispatch, getState) => {

        let teamStaff = getState().team_staff
        let staff = teamStaff.value.staff
        for (let m of staff) {
            if (m.user_id === member.user_id) {
                m.error = null
                m.loading = false
                break
            }
        }

        // force team staff to reload
        dispatch({
            type: 'COMMON_SET',
            key: 'team_staff',
            value: {
                loading: false,
                complete: true,
                value: {
                    team_id: teamStaff.value.team_id,
                    staff: teamStaff.value.staff
                },
                error: null
            },
            note: 'reset team member'
        })
        return
    }
}



export function updateTeamMember(divisionId, member, cb = null) {
    return (dispatch, getState) => {

        let origCoach = '0'
        let origManager = '0'

        let teamStaff = getState().team_staff
        let staff = teamStaff.value.staff ? teamStaff.value.staff : []
        let isFilled = false
        for (let m of staff) {
            if (m.user_id === member.user_id) {
                origCoach = m.is_coach
                origManager = m.is_videographer
                isFilled = m.filled_from_division_staff ? m.filled_from_division_staff : false
                m.error = null
                m.loading = true
                break
            }
        }

        // force team staff to reload
        if (cb === null) {
            dispatch({
                type: 'COMMON_SET',
                key: 'team_staff',
                value: {
                    loading: false,
                    complete: true,
                    value: {
                        team_id: teamStaff.value.team_id,
                        staff: teamStaff.value.staff
                    },
                    error: null
                },
                note: 'pre update role changer'
            })
            dispatch({ type: 'REV' })
        }

        webApi.updateTeamMember(member)
            .then((success) => {
                statAdminEvent(divisionId, 'update-members', 'teams')
                let staff = getState().team_staff.value.staff
                console.log('updateTeamMember success', success, isFilled)

                for (let m of staff) {
                    if (m.user_id === member.user_id) {
                        if (success) {
                            m.error = null
                            m.is_coach = member.is_coach
                            m.is_videographer = member.is_videographer
                            
                        } else {
                            m.is_coach = origCoach
                            m.is_videographer = origManager
                            m.error = 'Failed'
                        }
                        m.loading = false
                        break
                    }
                }

                if (cb) {
                    member.loading = false
                    member.error = success ? null : 'failed'
                    cb(member)
                }
                else {
                    dispatch({
                        type: 'COMMON_SET',
                        key: 'team_staff',
                        value: {
                            needs_reload: isFilled,
                            loading: false,
                            complete: true,
                            value: {
                                team_id: teamStaff.value.team_id,
                                staff: teamStaff.value.staff
                            },
                            error: null
                        },
                        note: 'post update role changer'
                    })
                    dispatch({ type: 'REV' })
                }
            })
    }
}

export function updateTeamMembers(divisionId, membersList) {
    return (dispatch) => {
        dispatch(updateTeamMembersRequest(membersList, (err) => {
            statAdminEvent(divisionId, 'update-members', 'teams')
            dispatch(loadTeamsByDivision(divisionId))
        }))
    }
}

export const ADD_TEAM_FAILED = 'ADD_TEAM_FAILED'
export function addTeamFailed() {
    return {
        type: ADD_TEAM_FAILED
    }
}

export const ADD_TEAM_SUCCEEDED = 'ADD_TEAM_SUCCEDED'
export function addTeamSucceded() {
    return {
        type: ADD_TEAM_SUCCEEDED
    }
}

export const ADD_TEAM_STARTED = 'ADD_TEAM_STARTED'
export function addTeamStarted() {
    return {
        type: ADD_TEAM_STARTED
    }
}

export const UPDATE_TEAM_FAILED = 'UPDATE_TEAM_FAILED'
export function updateTeamFailed() {
    return {
        type: UPDATE_TEAM_FAILED
    }
}

export const UPDATE_TEAM_SUCCEEDED = 'UPDATE_TEAM_SUCCEDED'
export function updateTeamSucceded() {
    return {
        type: UPDATE_TEAM_SUCCEEDED
    }
}

export const UPDATE_TEAM_STARTED = 'UPDATE_TEAM_STARTED'
export function updateTeamStarted() {
    return {
        type: UPDATE_TEAM_STARTED
    }
}

export function updateTeamRequest(teamId, data, callback) {
    return (dispatch) => {
        return webApi.updateTeam(teamId, data)
            .then(() => callback(), error => callback(error))
            .catch(err => callback(err))
    }
}

export function addTeamWithDivisionRequest(data, divisionId, userRoles, callback) {
    return (dispatch) => {
        return webApi.addTeam(data)
            .then(json => {
                for(let user of userRoles) {
                    user.team_id = json.team_id
                }
                console.log('addTeamWithDivisionRequest', userRoles)
                dispatch(webApi.addTeamToDivision(json.team_id, divisionId).then(
                    () => { webApi.batchUpdateTeamMembers(userRoles).then( () => callback(),
                        error => callback(error))
                    },
                    error => callback(error)
                ).catch(err => callback(err)))
            }, error => callback(error))
            .catch(err => callback(err))
    }
}

export function deleteTeamFromDivisionRequest(divisionTeamId, callback) {
    return (dispatch) => {
        return webApi.deleteTeamFromDivision(divisionTeamId)
            .then(json => callback(), error => callback(error))
            .catch(err => callback(err))
    }
}

export function updateTeamMembersRequest(membersList, callback) {
    return (dispatch) => {
        return webApi.batchUpdateTeamMembers(membersList)
            .then(json => callback(null, json), error => callback(error))
            .catch(err => callback(err))
    }
}

export function updateTeamMemberRequest(membersList, callback) {
    return (dispatch) => {
        return webApi.batchUpdateTeamMembers(membersList)
            .then(json => callback(null, json), error => callback(error))
            .catch(err => callback(err))
    }
}

export function loadTeamsRequest(callback) {
    return (dispatch) => {
        return webApi.getUserTeams()
            .then(teams => callback(null, teams), error => callback(new Error(error)))
            .catch(err => callback(err))
    }
}

export function loadTeamsRequestByDivision(divisionId, callback) {
    return (dispatch) => {
        return webApi.getDivisionTeams(divisionId)
            .then(teams => callback(null, teams), error => callback(new Error(error)))
            .catch(err => callback(err))
    }
}

export function loadUsersByTeamRequest(teamId, callback) {
    return (dispatch) => {
        return webApi.getTeamUsers(teamId)
            .then(users => callback(null, users), error => callback(new Error(error)))
            .catch(err => callback(err))
    }
}
